import React from "react";
import Preloader from "../utilities/Preloader";
import { PiggyBank, Calculator, ShieldCheck, Percent } from "lucide-react";

export const Features = (props) => {
  const getIcon = (iconName, title) => {
    const t = (title || "").toLowerCase();
    if (t.includes("saving") || iconName?.includes("piggy")) {
      return <PiggyBank size={32} />;
    }
    if (t.includes("accounting") || iconName?.includes("calculator")) {
      return <Calculator size={32} />;
    }
    if (t.includes("security") || t.includes("safety") || iconName?.includes("shield")) {
      return <ShieldCheck size={32} />;
    }
    if (t.includes("rate") || iconName?.includes("magic")) {
      return <Percent size={32} />;
    }
    return <i className={iconName}></i>;
  };

  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Features</h2>
        </div>
        <div className="row g-4 justify-content-center">
          {props.data ? (
            props.data.map((d, i) => (
              <div key={`${d.title}-${i}`} className="col-12 col-md-6 col-lg-3">
                <div className="feature-item">
                  <div className="feature-icon-wrapper">
                    {getIcon(d.icon, d.title)}
                  </div>
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              </div>
            ))
          ) : (
            <Preloader />
          )}
        </div>
      </div>
    </div>
  );
};

export default Features;
